import React from 'react';

import BrandConfigs from 'config/brand-resolution';

const Logo = () => <BrandConfigs.Logo />;

export default Logo;
